import styles from './ArticleDetailHeadInfos.module.scss'
import { showRepublishingHint } from '@/elements/widgets/Article/ArticleDetailHead'
import { clsx } from 'clsx'

const Publication = ({ item, className }: { item: any; className?: string }) => {
  const current = new Date(item.model.republishing ? item.model.lastmodifiedAt : item.model.publishedAt)
  const date = current.toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })

  const time = current.toLocaleString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
  })

  return (
    <span className={clsx(styles['publication-date'], className)}>
      {date} | {time} Uhr{' '}
      {showRepublishingHint(item.model.republishing, item.model.publishedAt, item.model.lastmodifiedAt)
        ? '(aktualisiert)'
        : ''}
    </span>
  )
}

export default Publication
